<template>
  <div class="form-group">
    <label
      v-if="titulo != 'hide'"
      v-bind:class="{
        'text-danger':
          current.errors.unidad_medida &&
          current.errors.unidad_medida.length > 0,
      }"
      >{{ titulo }}</label
    >
    <select
      class="form-control"
      v-model="current.unidad_medida"
      @change="onChangeSelect($event)"
    >
      <option
        v-for="(unidad_medida, key) in unidades_medidas"
        :value="unidad_medida.id"
        :key="key"
      >
        {{ unidad_medida.nombre }}
      </option>
    </select>
    <small
      v-if="current.errors && current.errors.unidad_medida"
      class="form-text text-danger"
      >{{ current.errors.unidad_medida[0] }}</small
    >
  </div>
</template>

<script>
import DynamicService from "@/services/commons/DynamicService";

export default {
  props: {
    current: {
      type: Object,
      required: true,
    },
    titulo: {
      type: String,
      default: "Unidad Medida",
    },
  },
  computed: {},
  data() {
    return {
      unidades_medidas: [],
    };
  },
  watch: {
    'current.producto': {
      refreshUnidadMedida(producto) {
      if (!producto || !producto.sku) return;
      },

      handler(newVal) {
        if (newVal && newVal.sku) {
          this.refreshDataUnidadmedidaSolicitud();
        }
      },
      deep: true
    }
  },
  mounted() {
    if (this.current.producto && this.current.producto.sku && typeof this.current.producto.sku === 'string' && this.current.producto.sku.trim()) {
      this.refreshDataUnidadmedidaSolicitud();
    }
  },
  methods: {
    refreshDataUnidadmedidaSolicitud() {
      if (!this.current.producto || !this.current.producto.sku) return;

      let self = this;
      let producto_id = this.current.producto.sku;
  
      DynamicService.getById("cat", "productos", producto_id)
      .then((res) => {
        const data = res.data && res.data.unidad_medida_compra_obj;
        let unidades_medidas_producto = res.data.productounidadmedida_set;

        //Se asigna la UoM de compra y si es solo 1 se envuelve con [] para convertirlo en array
        if (!data) {
          self.unidades_medidas = [];
        } else if (Array.isArray(data)) {
          self.unidades_medidas = data;
        } else {
          self.unidades_medidas = [data];
        }
        
        //Se añaden las UoM que asignadas al producto
        unidades_medidas_producto.forEach(unidad => {
          const unidadMedidaNueva = unidad.unidad_medida;
          const yaExiste = self.unidades_medidas.some(
            umExistente => umExistente.id === unidadMedidaNueva.id
          );

          if (!yaExiste){
            self.unidades_medidas.push(unidadMedidaNueva);
          }
        });
      });
    },
    onChangeSelect(event) {
      const value = event && event.target ? event.target.value : this.current.unidad_medida;
      this.$emit("onchangeselect", value);
    },
  },
};
</script>